import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@app/api/auth/auth.service';
import { OrganizacoesService } from '@app/api/organizacoes/organizacoes.service';
import { resolveOrganizacao } from '@app/shared/utils/resolve-organizacao';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

/**
 * Guard específico para rotas de proposta na jornada offline.
 * Se não autenticado, redireciona para sign-in com returnUrl preservado.
 */
export const PropostaAuthGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const organizacoesService = inject(OrganizacoesService);
  const rotaAtual = resolveOrganizacao(route, state);

  return organizacoesService.getOrganizacao(rotaAtual).pipe(
    map((organizacao) => {
      if (!organizacao) {
        return router.createUrlTree(['/']);
      }
      if (authService.isLogged) {
        return true;
      }
      // Jornada Offline: redireciona para sign-in preservando returnUrl
      const returnUrl = state.url;
      return router.createUrlTree(
        [`/${rotaAtual}/auth/sign-in`],
        { queryParams: { returnUrl } }
      );
    }),
    catchError((error) => {
      console.error('PropostaAuthGuard error:', error);
      return of(router.createUrlTree(['/']));
    })
  );
};
